// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  overflow: hidden;
}

.category-visual-svg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.category-visual-svg ::ng-deep svg {
  width: 48px;
  height: 48px;
  max-width: 70%;
  max-height: 70%;
  fill: #333;
}

.category-visual--sm .category-visual-svg ::ng-deep svg {
  width: 22px;
  height: 22px;
  max-width: 100%;
  max-height: 100%;
}

.category-visual-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.category-visual-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-family: var(--brand-font-family, "Helvetica Neue", Arial, sans-serif);
  font-weight: 700;
  font-size: 1.75rem;
  letter-spacing: 0.02em;
  color: var(--brand-icon, var(--brand-accent, #2563eb));
  background: var(--brand-icon-soft, color-mix(in srgb, var(--brand-accent, #2563eb) 12%, white));
  -webkit-user-select: none;
          user-select: none;
}

.category-visual--sm .category-visual-letter {
  font-size: 0.85rem;
}

.category-visual--letter {
  border-radius: inherit;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/category-visual/category-visual.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sDAAA;EACA,+FAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF","sourcesContent":[".category-visual {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  overflow: hidden;\n}\n\n.category-visual-svg {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  ::ng-deep svg {\n    width: 48px;\n    height: 48px;\n    max-width: 70%;\n    max-height: 70%;\n    fill: #333;\n  }\n}\n\n.category-visual--sm .category-visual-svg ::ng-deep svg {\n  width: 22px;\n  height: 22px;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.category-visual-photo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.category-visual-letter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-family: var(--brand-font-family, 'Helvetica Neue', Arial, sans-serif);\n  font-weight: 700;\n  font-size: 1.75rem;\n  letter-spacing: 0.02em;\n  color: var(--brand-icon, var(--brand-accent, #2563eb));\n  background: var(--brand-icon-soft, color-mix(in srgb, var(--brand-accent, #2563eb) 12%, white));\n  user-select: none;\n}\n\n.category-visual--sm .category-visual-letter {\n  font-size: 0.85rem;\n}\n\n.category-visual--letter {\n  border-radius: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
